import { RuleEntity, ScoreEnum } from 'store/api/apiTypes';
import { useCachedRuleFactory } from './useCachedRuleFactory';
/** Wrapper around factory providing conversational writing rule cached data. */
export const useCachedConversationalWritingRule = () => {
  const base = useCachedRuleFactory('getConversationalWritingRule');
  // Count products with assessment_score < 2 (i.e. LOW =1) treated as "successful".
  // If assessment_score missing, exclude from success count.
  let successfulProductsCount = 0;
  const productMap = base.ruleData?.products as
    | Record<string, RuleEntity>
    | undefined;
  if (productMap) {
    Object.values(productMap).forEach(prod => {
      const score = prod?.assessment_score;
      if (score === ScoreEnum.HIGH) {
        successfulProductsCount += 1;
      }
    });
  }
  return {
    ...base,
    companyAssessment: base.company?.assessment_explanation || '',
    productKeys: base.ruleData ? Object.keys(base.ruleData.products || {}) : [],
    passed: successfulProductsCount,
  };
};
